import React, { useEffect } from 'react';
import { Container, Typography, Box, Link, useTheme } from '@mui/material';

const TermsOfService = () => {
  const theme = useTheme();

  useEffect(() => {
    document.getElementById("year").textContent = new Date().getFullYear();
  }, []);

  const styles = {
    body: {
      margin: 0,
      fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '2rem',
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem',
    },
    headerImg: {
      maxWidth: '160px',
      height: 'auto',
    },
    h1: {
      fontSize: '2rem',
      marginBottom: '1rem',
      color: theme.palette.primary.main,
      fontWeight: 700,
      textAlign: 'center',
    },
    p: {
      fontSize: '1.05rem',
      lineHeight: 1.6,
    },
    main: {
      maxWidth: '650px',
      background: theme.palette.background.paper,
      padding: '2rem',
      borderRadius: '8px',
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    footer: {
      marginTop: '3rem',
      fontSize: '0.9rem',
      color: theme.palette.text.secondary,
      textAlign: 'center',
    },
  };

  return (
    <Box sx={styles.body}>
      <header style={styles.header}>
        <img src="https://imagizer.imageshack.com/v2/280x200q70/924/1yx2xL.png" alt="gdscreate automations" style={styles.headerImg} />
        <Typography variant="h1" component="h1" sx={styles.h1}>
          Terms of Service
        </Typography>
      </header>

      <Box component="main" sx={styles.main}>
        <Typography variant="body1" component="p" sx={{ ...styles.p, fontStyle: 'italic' }}>
          Last updated: July 4, 2025
        </Typography>
        <br />
        <Typography variant="body1" component="p" sx={styles.p}>
          By authorizing this application, you agree to allow it to access your Google Sheets data solely for automations you initiate or configure.
        </Typography>
        <br />
        <Typography variant="body1" component="p" sx={styles.p}>
          You retain full control of your data, and may revoke access at any time via your Google account settings. This service is provided "as is" with no warranties, and we are not responsible for any indirect damages or data loss.
        </Typography>
      </Box>

      <footer style={styles.footer}>
        &copy; <span id="year"></span> gdscreate. All rights reserved.
      </footer>
    </Box>
  );
};

export default TermsOfService;
